/**
 * Validation mixins for RfForm
 */
export default {
  methods: {
    /**
     * Clears validation UI for all fields in the form
     */
    clearFormValidation () {
      this.getFields().forEach(function (field) {
        field.clearValidation()
      })
    },

    /**
     * Scroll the window so the first validation error is visible and focus the field
     */
    scrollToFirstError () {
      // Without $nextTick(), this.errors.items[0] is undefined and I can't quite
      // figure out why.
      // UPDATE 8/26/2021 - I think because vee-validate works async with promises
      // and using nextTick essentially gives it "time" to resolve. How did I not
      // realize this before??
      this.$nextTick(function () {
        // We need to get the first field (as it appears in the DOM) that
        // has an error. using this.getFields() may not return child VMs
        // in the order they appear in the DOM, especially when some fields
        // are conditionally rendered.
        // So we'll first get the first error field as it appears in DOM
        let firstErrorEl = this.$refs.form.querySelector('.rf-field.is-invalid')
        // Then we'll find out which of our child VMs matches
        let firstErrorField = null
        this.getFields().forEach(function (fieldVm) {
          if (fieldVm.$el.isEqualNode(firstErrorEl)) {
            firstErrorField = fieldVm
          }
        })
        if (typeof this.errors.items[0] === 'undefined' || !firstErrorField) { return }
        this.$scrollTo(firstErrorField.$el, 350, { easing: 'ease-out', offset: this._getScrollToOffset(firstErrorField.$el) })
        firstErrorField.focus()
      })
    },

    /**
     * Get appropriate scrollTo offset
     *
     * Sometimes an element is very low on the page, and there's no room to
     * scroll past it so that it appears at the top of the window. So we do some
     * calculations to determine how much space there is below an element, and
     * adjust the scrollTo offset accordingly. This ensures the scrollTo
     * animation is smooth
     * @param   {HTMLElement}   el The element to scroll to
     * @param   {Number}        padding How much padding to leave above the
     * element
     */
    _getScrollToOffset (el, padding = 30) {
      let docHeight = document.height || document.body.offsetHeight
      let toBottom = docHeight - el.getBoundingClientRect().top + padding
      let bottomDif = toBottom - window.innerHeight
      let offset = -padding
      if (toBottom < window.innerHeight) {
        offset = bottomDif
      }

      return offset
    }
  }
}



// WEBPACK FOOTER //
// ./src/frontend/mixins/form/validation.js